"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: client-proxy/account-data.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fclient-proxy%2Faccount-data.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flex = exports.AccountDataSubAccountBalancesEntry = exports.AccountData = void 0;
const account_1 = require("../account/account");
const billed_account_1 = require("../billing/billed-account");
const statement_1 = require("../billing/statement");
const card_1 = require("../card/card");
const amount_1 = require("../common/amount");
const protobufPackage = 'com.step.clientproxy.proto';
function createBaseAccountData() {
    return {
        account: account_1.Account.fromPartial({}),
        balance: amount_1.Amount.fromPartial({}),
        cards: [],
        subAccountBalances: {},
        flex: undefined,
    };
}
exports.AccountData = {
    fromJSON(object) {
        const message = {
            account: isSet(object.account) ? account_1.Account.fromJSON(object.account) : account_1.Account.fromPartial({}),
            balance: isSet(object.balance) ? amount_1.Amount.fromJSON(object.balance) : amount_1.Amount.fromPartial({}),
            cards: globalThis.Array.isArray(object?.cards)
                ? object.cards.map((e) => card_1.Card.fromJSON(e))
                : [],
            subAccountBalances: isObject(object.subAccountBalances)
                ? Object.entries(object.subAccountBalances).reduce((acc, [key, value]) => {
                    acc[key] = amount_1.Amount.fromJSON(value);
                    return acc;
                }, {})
                : {},
        };
        if (isSet(object.flex)) {
            message.flex = exports.Flex.fromJSON(object.flex);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.account !== undefined) {
            obj.account = account_1.Account.toJSON(message.account);
        }
        if (message.balance !== undefined) {
            obj.balance = amount_1.Amount.toJSON(message.balance);
        }
        if (message.cards?.length) {
            obj.cards = message.cards.map((e) => card_1.Card.toJSON(e));
        }
        if (message.subAccountBalances) {
            const entries = Object.entries(message.subAccountBalances);
            if (entries.length > 0) {
                obj.subAccountBalances = {};
                entries.forEach(([k, v]) => {
                    obj.subAccountBalances[k] = amount_1.Amount.toJSON(v);
                });
            }
        }
        if (message.flex !== undefined) {
            obj.flex = exports.Flex.toJSON(message.flex);
        }
        return obj;
    },
    create(base) {
        return exports.AccountData.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAccountData();
        message.account = (object.account !== undefined && object.account !== null)
            ? account_1.Account.fromPartial(object.account)
            : account_1.Account.fromPartial({});
        message.balance = (object.balance !== undefined && object.balance !== null)
            ? amount_1.Amount.fromPartial(object.balance)
            : amount_1.Amount.fromPartial({});
        message.cards = object.cards?.map((e) => card_1.Card.fromPartial(e)) || [];
        message.subAccountBalances = Object.entries(object.subAccountBalances ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = amount_1.Amount.fromPartial(value);
            }
            return acc;
        }, {});
        message.flex = (object.flex !== undefined && object.flex !== null)
            ? exports.Flex.fromPartial(object.flex)
            : undefined;
        return message;
    },
};
function createBaseAccountDataSubAccountBalancesEntry() {
    return { key: '', value: undefined };
}
exports.AccountDataSubAccountBalancesEntry = {
    fromJSON(object) {
        const message = {
            key: isSet(object.key) ? globalThis.String(object.key) : '',
        };
        if (isSet(object.value)) {
            message.value = amount_1.Amount.fromJSON(object.value);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== '') {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = amount_1.Amount.toJSON(message.value);
        }
        return obj;
    },
    create(base) {
        return exports.AccountDataSubAccountBalancesEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAccountDataSubAccountBalancesEntry();
        message.key = object.key ?? '';
        message.value = (object.value !== undefined && object.value !== null)
            ? amount_1.Amount.fromPartial(object.value)
            : undefined;
        return message;
    },
};
function createBaseFlex() {
    return { statement: undefined, billedAccount: billed_account_1.BilledAccount.fromPartial({}) };
}
exports.Flex = {
    fromJSON(object) {
        const message = {
            billedAccount: isSet(object.billedAccount)
                ? billed_account_1.BilledAccount.fromJSON(object.billedAccount)
                : billed_account_1.BilledAccount.fromPartial({}),
        };
        if (isSet(object.statement)) {
            message.statement = statement_1.StatementV2.fromJSON(object.statement);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.statement !== undefined) {
            obj.statement = statement_1.StatementV2.toJSON(message.statement);
        }
        if (message.billedAccount !== undefined) {
            obj.billedAccount = billed_account_1.BilledAccount.toJSON(message.billedAccount);
        }
        return obj;
    },
    create(base) {
        return exports.Flex.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFlex();
        message.statement = (object.statement !== undefined && object.statement !== null)
            ? statement_1.StatementV2.fromPartial(object.statement)
            : undefined;
        message.billedAccount = (object.billedAccount !== undefined && object.billedAccount !== null)
            ? billed_account_1.BilledAccount.fromPartial(object.billedAccount)
            : billed_account_1.BilledAccount.fromPartial({});
        return message;
    },
};
function isObject(value) {
    return typeof value === 'object' && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=account-data.js.map